import { render, staticRenderFns } from "./GSelectServer.vue?vue&type=template&id=08b6989e&"
import script from "./GSelectServer.vue?vue&type=script&lang=js&"
export * from "./GSelectServer.vue?vue&type=script&lang=js&"
import style0 from "./GSelectServer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports